/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"
import { theme } from "styles/theme"

export const announcementBannerContainer = css`
  padding: 10px 32px 10px 10px;
  border: 1px solid ${theme.colors.border};
  box-sizing: border-box;
  border-radius: 8px;
  margin-bottom: 35px;
  position: relative;
  background: linear-gradient(180deg, #ffffff 0%, #f6f6f6 100%);

  p {
    font-family: "Inter Grab Web";
    margin-bottom: 0;
  }

  .ant-row-flex {
    flex-wrap: nowrap;
  }
`

export const announcementBannerTitle = css`
  font-size: ${theme.fontSize.h2};
  font-weight: 500;
  color: #2d2d2d;
`

export const announcementBannerDescription = css`
  color: #979797;
`

export const announcementBannerTag = css`
  position: absolute;
  top: -10px;
  left: -10px;
`
